import { Injectable } from '@angular/core'
import { MomentDateAdapter } from '@angular/material-moment-adapter'

@Injectable()
export class AppCustomDateAdapter extends MomentDateAdapter {
   override getFirstDayOfWeek(): number {
      return 1
   }
}

export const CUSTOM_DATE_FORMATS = {
   parse: {
      dateInput: 'DD/MM/YYYY'
   },
   display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MM YYYY',
      dateA11yLabel: 'DD/MM/YYYY',
      monthYearA11yLabel: 'MM YYYY'
   }
}
